// @flow
import React from 'react';
import classnames from 'classnames';
import tickWhite from 'assets/icons/tickWhite.svg';
import styles from './styles.module.scss';
import P from '../Typography/P';

type Props = {
  title: string,
  text: string,
  price: string,
  backGround: string,
  features: Array<string>,
  button: Node,
  isYear?: boolean,
  oldPrice?: string,
  type?: string,
  subtext?: string,
  borderTopColor?: string,
  isCombination?: boolean,
  percentage?: string,
  percentageColor?: string,
}

const PricingCard = ({
  title, text, price, backGround, features, button, isYear = false, oldPrice = '', type, subtext, borderTopColor, isCombination = false, percentage = '', percentageColor,
}: Props) => {
  const bg = {
    background: backGround,
    borderTop: `2px solid ${borderTopColor}`,
    borderRadius: isCombination ? '10px' : '2px 2px 16px 16px',
  };
  return (
    <div
      style={bg}
      className={classnames(styles.pricingCardContainer, `${isCombination ? styles.combinationWidth : styles.nonCombinationWidth}`)}
    >
      <div className={styles.blockTop}>
        <div className={styles.titleWrapper}>
          <span className={styles.cardTitle}>
            {title}
          </span>
          <P className={styles.title} size="big">{text}</P>
        </div>
        <div className={styles.featuresWrapper}>
          {features.map((feature, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <section className={styles.feature} key={`${index}`}>
              <img src={tickWhite} alt="o" />
              <P size="big">
                {feature}
              </P>
            </section>
          ))}
        </div>
      </div>
      <div>
        {
          isYear && price !== 'FREE' ? (
            <div className={styles.oldPriseWrapper}>
              <div className={styles.oldPrise}>{oldPrice}</div>
              <div className={styles.percentage} style={{ backgroundColor: percentageColor }}>
                {percentage}
              </div>
            </div>
          ) : null
        }
        <div className={styles.priceWrapper}>
          <span className={styles.price}>{price}</span>
          {price !== 'TRIAL' && <span className={styles.priceType}>{type}</span>}
        </div>
        {
          subtext ? (
            <div className={styles.textPayment}>
              {subtext}
            </div>
          ) : null
        }
        {button}
      </div>
    </div>
  );
};
export default PricingCard;
